module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employee/templates/dashboard/Leave.ejs -->\n<div class="ibox-content">\n    <div class="row is-marginless">\n        <div class="col-sm-3 col-xs-12 text-center m-t-lg">\n            <canvas class="js-chart" width="160" height="160"></canvas>\n        </div>\n        <div class="col-sm-9">\n            <div class="row m-b-lg">\n                ';
 leaveTypes.forEach(function (type) { 
__p+='\n                    <div class="col-sm-3 col-xs-4">\n                        <div class="h1">'+
((__t=( type.getTaken() ))==null?'':_.escape(__t))+
'</div>\n                        <div>\n                            '+
((__t=( type.get('name') ))==null?'':_.escape(__t))+
'\n                            ';
 print(type.getTaken() === 1 ? 'Day' : 'Days') 
__p+=' Taken\n                        </div>\n                    </div>\n                ';
 }); 
__p+='\n                <div class="col-sm-3 col-xs-4">\n                    <div class="h1">'+
((__t=( annualExtraCounters.entitled ))==null?'':_.escape(__t))+
'</div>\n                    <div>\n                        Annual Leave Entitled Days\n                    </div>\n                </div>\n\n                <div class="col-sm-3 col-xs-4">\n                    <div class="h1">'+
((__t=( annualExtraCounters.carryForward ))==null?'':_.escape(__t))+
'</div>\n                    <div>\n                        Annual Leave Carried Forward Days\n                    </div>\n                </div>\n\n                <div class="col-sm-3 col-xs-4">\n                    <div class="h1">'+
((__t=( annualExtraCounters.remaining ))==null?'':_.escape(__t))+
'</div>\n                    <div>\n                        Annual Leave Remaining Days\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n    <div class="text-right">\n        <a href="#calendar" type="button" class="btn btn-outline btn-success btn-w-m">\n            Calendar\n        </a>\n        <a href="#requestLeave/add" type="button" class="btn btn-outline btn-primary btn-w-m">\n            Apply Leave\n        </a>\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employee/templates/dashboard/Leave.ejs
// module id = 1052
// module chunks = 1